
    import '/vercel/path0/docs/demo/draggable.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-draggable-demo-draggable"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/draggable.md?type=demo')
};